import { useState, useEffect } from "react";

const formatTime = (decimalTime) => {
  const totalSeconds = decimalTime * 60;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.round(totalSeconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

const Timer = ({ initialTime }) => {
  const [time, setTime] = useState(formatTime(initialTime));

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime((prevTime) => {
        const [minutes, seconds] = prevTime.split(":").map(Number);
        let newSeconds = seconds + 1;
        let newMinutes = minutes;
        if (newSeconds >= 60) {
          newSeconds = 0;
          newMinutes += 1;
        }
        return `${String(newMinutes).padStart(2, "0")}:${String(newSeconds).padStart(
          2,
          "0",
        )}`;
      });
    }, 1000);
    return () => clearInterval(timerId);
  }, []);
  return <span>{time}</span>;
};

export default Timer;
